import { render, staticRenderFns } from "./CertDashboard.vue?vue&type=template&id=00961932&scoped=true&lang=html&"
import script from "./CertDashboard.vue?vue&type=script&lang=js&"
export * from "./CertDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CertDashboard.vue?vue&type=style&index=0&id=00961932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00961932",
  null
  
)

export default component.exports